'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withContentCardFooter;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCard = require('../components/ContentCard');

var _ContentCard2 = _interopRequireDefault(_ContentCard);

var _ContentCardFooter = require('../components/ContentCardFooter');

var _ContentCardFooter2 = _interopRequireDefault(_ContentCardFooter);

var _ExternalContentCardSource = require('../components/ExternalContentCardSource');

var _ExternalContentCardSource2 = _interopRequireDefault(_ExternalContentCardSource);

var _TheScoreContentCardSource = require('../components/TheScoreContentCardSource');

var _TheScoreContentCardSource2 = _interopRequireDefault(_TheScoreContentCardSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var getExtraFooterProps = function getExtraFooterProps(componentProps, name) {
  switch (name) {
    case 'InstagramPhotoContentCard':
    case 'InstagramVideoContentCard':
      return {
        source: componentProps.authorHandle + ' on instagram',
        shareText: componentProps.text,
        url: componentProps.mediaPageUri
      };
    case 'TwitterGalleryContentCard':
    case 'TwitterPhotoContentCard':
    case 'TwitterTextContentCard':
    case 'TwitterVideoContentCard':
    case 'TwitterVideoStreamContentCard':
      return {
        source: componentProps.authorHandle + ' on twitter',
        shareText: componentProps.text,
        url: componentProps.url || null
      };
    case 'RotoPlayerNewsContentCard':
    case 'RotoPlayerStatsContentCard':
      return {
        source: 'rotowire',
        shareText: componentProps.title || componentProps.name
      };
    case 'SourcedArticleCard':
      return {
        source: _react2.default.createElement(_ExternalContentCardSource2.default, { text: componentProps.siteName }),
        shareText: componentProps.title,
        fontSize: componentProps.footerFontSize,
        shareArrowHeight: componentProps.shareArrowHeight,
        shareArrowWidth: componentProps.shareArrowWidth,
        footerMinHeight: componentProps.footerMinHeight
      };
    case 'TheScoreArticleContentCardItem':
      return {
        source: _react2.default.createElement(_TheScoreContentCardSource2.default, null),
        shareText: componentProps.title
      };
    case 'YouTubeContentCard':
      return {
        source: componentProps.channelTitle + ' on youtube',
        shareText: componentProps.title,
        url: componentProps.url
      };
    // no default
  }
  return {};
};

function withContentCardFooter(WrappedComponent) {
  var componentName = getDisplayName(WrappedComponent);

  // eslint-disable-next-line react/prefer-stateless-function

  var WithContentCardFooter = function (_React$Component) {
    _inherits(WithContentCardFooter, _React$Component);

    function WithContentCardFooter() {
      _classCallCheck(this, WithContentCardFooter);

      return _possibleConstructorReturn(this, (WithContentCardFooter.__proto__ || Object.getPrototypeOf(WithContentCardFooter)).apply(this, arguments));
    }

    _createClass(WithContentCardFooter, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            publishedAt = _props.publishedAt,
            shareUrl = _props.shareUrl,
            trackEvent = _props.trackEvent,
            componentProps = _objectWithoutProperties(_props, ['publishedAt', 'shareUrl', 'trackEvent']);

        var footerProps = Object.assign({
          publishedAt: publishedAt,
          shareUrl: shareUrl,
          trackEvent: trackEvent
        }, getExtraFooterProps(componentProps, componentName));
        return _react2.default.createElement(
          _ContentCard2.default,
          null,
          _react2.default.createElement(WrappedComponent, this.props),
          _react2.default.createElement(_ContentCardFooter2.default, footerProps)
        );
      }
    }]);

    return WithContentCardFooter;
  }(_react2.default.Component);

  WithContentCardFooter.displayName = 'WithContentCardFooter(' + componentName + ')';

  WithContentCardFooter.propTypes = {
    publishedAt: _propTypes2.default.string.isRequired,
    shareUrl: _propTypes2.default.string,
    trackEvent: _propTypes2.default.func
  };

  WithContentCardFooter.defaultProps = {
    shareUrl: null,
    trackEvent: null
  };

  return WithContentCardFooter;
}